$(document).ready(function () {
  // $('ul.tabs li').click(function () {
  //   var tab_id = $(this).attr('data-tab');

  //   $('ul.tabs li').removeClass('current');
  //   $('.tab-content').removeClass('current');

  //   $(this).addClass('current');
  //   $("#" + tab_id).addClass('current');
  // });

  if ($(".rolex_sidebar .tag-list--checkboxes .tag--active").is(":visible")) {
    $(".btn.rolex_reset_filters_btn").addClass("has_hover");
    $("a.btn.rolex_reset_filters_btn").css("cursor", "pointer");
  } else {
    $(".btn.rolex_reset_filters_btn").removeClass("has_hover");
  }


  $(".rolex_collection_filter i.fas").on('click', function () {
    if ($(".rolex_sidebar div#CollectionSidebarFilterWrap").is(":visible")) {
      $(this).removeClass("fa-times");
      $(this).addClass("fa-plus");
      $(".rolex_collection_filter").removeClass("open");

      $(".rolex_sidebar div#CollectionSidebarFilterWrap").removeClass("rolex_sidebar_filter_list");
    } else {
      $(this).removeClass("fa-plus");
      $(this).addClass("fa-times");
      $(".rolex_sidebar div#CollectionSidebarFilterWrap").addClass("rolex_sidebar_filter_list");
      $(".rolex_collection_filter").addClass("open");
    }

  });

  $(".mob_filter i.fas").on('click', function () {
    if ($(".collection-sidebar.open").is(":visible")) {
      $(this).removeClass("fa-times");
      $(this).addClass("fa-plus");
      $(".collection-sidebar.small--hide").removeClass("open");
    } else {
      $(this).removeClass("fa-plus");
      $(this).addClass("fa-times");
      $(".collection-sidebar.small--hide").addClass("open");
    }

  });


});
